import {ActionCreator, createAction} from '@packages/utilities/create-action';

export const ONBOARDING_INITIATED = 'ONBOARDING_INITIATED' as const;
export const ONBOARDING_DISMISSED = 'ONBOARDING_DISMISSED' as const;
export const ONBOARDING_STEP_CONTINUED = 'ONBOARDING_STEP_CONTINUED' as const;
export const ONBOARDING_STEP_REVERSED = 'ONBOARDING_STEP_REVERSED' as const;
export const ONBOARDING_STEP_SKIPPED = 'ONBOARDING_STEP_SKIPPED' as const;

/** Starts the onboarding tutorial for a given tutorial */
const initOnboarding: ActionCreator<
  typeof ONBOARDING_INITIATED,
  {
    tutorial: string;
    stepsCompleted?: Array<string>;
    currentStepId?: string | null;
    resumedCount?: number;
  }
> = createAction(ONBOARDING_INITIATED);

/**
 * Helper action that enables experiences that only requires a simple user
 * interaction, such as clicking a "Next" button.
 */
const stepContinued: ActionCreator<typeof ONBOARDING_STEP_CONTINUED, void> =
  createAction(ONBOARDING_STEP_CONTINUED);

/**
 * Helper action that enables experiences that only requires a simple user
 * interaction, such as clicking a "Previous" button.
 */
const stepReversed: ActionCreator<typeof ONBOARDING_STEP_REVERSED, void> =
  createAction(ONBOARDING_STEP_REVERSED);

/**
 * Helper action that allows for dynamic experiences that require skipping
 * to a speficic step
 */
const stepSkipped: ActionCreator<
  typeof ONBOARDING_STEP_SKIPPED,
  {
    nextStepId: string;
  }
> = createAction(ONBOARDING_STEP_SKIPPED);

/**
 * Helper action to set a tutorial's status to `dismissed`
 */
const dismissOnboarding: ActionCreator<
  typeof ONBOARDING_DISMISSED,
  {
    tutorial: string;
    nextStepId?: string;
  }
> = createAction(ONBOARDING_DISMISSED);

export const ActionTypes = {
  ONBOARDING_INITIATED,
  ONBOARDING_STEP_CONTINUED,
  ONBOARDING_STEP_REVERSED,
  ONBOARDING_STEP_SKIPPED,
  ONBOARDING_DISMISSED,
} as const;

export const Actions = {
  dismissOnboarding,
  initOnboarding,
  stepContinued,
  stepReversed,
  stepSkipped,
} as const;
